export const SET_CARDS = "SET_CARDS";
export const SET_TABLE = "SET_TABLE";
export const SET_PAYMENTMETHON_LIST= "SET_PAYMENTMETHON_LIST";